<div
  class="tk-wrap"
  [class.tk-mode-page]="mode === 'page'"
  [class.tk-mode-section]="mode === 'section'"
  [class.tk-mode-card]="mode === 'card'"
  role="region"
  [attr.aria-label]="(titleKey() | transloco)"
>
  <!-- Particules flottantes (background) -->
  <div class="tk-particles" aria-hidden="true">
    <span
      *ngFor="let p of particles; let i = index"
      class="tk-particle"
      [style.--i]="i"
    ></span>
  </div>

  <!-- Glow halo derrière le logo -->
  <div class="tk-halo" aria-hidden="true"></div>

  <div class="tk-stage">
    <!-- Logo TikTok stylisé (note de musique double, glitch néon) -->
    <div class="tk-logo" aria-hidden="true">
      <svg viewBox="0 0 64 64" class="tk-logo-svg" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="tkGrad1" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#25F4EE" />
            <stop offset="100%" stop-color="#25F4EE" stop-opacity="0.4" />
          </linearGradient>
          <linearGradient id="tkGrad2" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#FE2C55" />
            <stop offset="100%" stop-color="#FE2C55" stop-opacity="0.4" />
          </linearGradient>
        </defs>
        <!-- Couche cyan décalée -->
        <path class="tk-note tk-note-cyan"
              d="M40 10 c0 5 3 10 9 11 v8 c-4 0 -7 -1 -10 -3 v15 c0 8 -6 14 -14 14 c-8 0 -14 -6 -14 -14 c0 -8 6 -14 14 -14 v8 c-3 0 -6 3 -6 6 c0 3 3 6 6 6 c3 0 6 -3 6 -6 V10 z"
              fill="url(#tkGrad1)"/>
        <!-- Couche magenta décalée -->
        <path class="tk-note tk-note-magenta"
              d="M40 10 c0 5 3 10 9 11 v8 c-4 0 -7 -1 -10 -3 v15 c0 8 -6 14 -14 14 c-8 0 -14 -6 -14 -14 c0 -8 6 -14 14 -14 v8 c-3 0 -6 3 -6 6 c0 3 3 6 6 6 c3 0 6 -3 6 -6 V10 z"
              fill="url(#tkGrad2)"/>
        <!-- Couche blanche au-dessus -->
        <path class="tk-note tk-note-white"
              d="M40 10 c0 5 3 10 9 11 v8 c-4 0 -7 -1 -10 -3 v15 c0 8 -6 14 -14 14 c-8 0 -14 -6 -14 -14 c0 -8 6 -14 14 -14 v8 c-3 0 -6 3 -6 6 c0 3 3 6 6 6 c3 0 6 -3 6 -6 V10 z"
              fill="#fff"/>
      </svg>
    </div>

    <!-- Badge Coming Soon -->
    <div class="tk-badge">
      <span class="tk-badge-dot"></span>
      <span class="tk-badge-text">{{ 'marketing.tiktok.badge' | transloco }}</span>
    </div>

    <!-- Titre glitch -->
    <h1 class="tk-title" [attr.data-text]="(titleKey() | transloco)">
      {{ titleKey() | transloco }}
    </h1>

    <p class="tk-sub">{{ 'marketing.tiktok.subtitle' | transloco }}</p>

    <!-- Equalizer audio -->
    <div class="tk-equalizer" aria-hidden="true">
      <span
        *ngFor="let b of bars; let i = index"
        class="tk-bar"
        [style.--i]="i"
      ></span>
    </div>

    <!-- Features prévues -->
    <ul *ngIf="showFeatures" class="tk-features">
      <li *ngFor="let f of featuresPlanned" class="tk-feature">
        <span class="material-icons-outlined tk-feature-icon">{{ f.icon }}</span>
        <span class="tk-feature-text">{{ f.key | transloco }}</span>
      </li>
    </ul>

    <!-- CTA inscription -->
    <div *ngIf="showCta" class="tk-cta-wrap">
      <button
        type="button"
        class="tk-cta"
        [class.tk-cta-done]="subscribed()"
        (click)="notifyMe()"
        [disabled]="subscribed()"
        [attr.aria-pressed]="subscribed()"
      >
        <span class="material-icons-outlined">
          {{ subscribed() ? 'check_circle' : 'notifications_active' }}
        </span>
        <span>
          {{
            (subscribed()
              ? 'marketing.tiktok.cta_subscribed'
              : 'marketing.tiktok.cta_notify') | transloco
          }}
        </span>
      </button>
      <p class="tk-cta-hint">{{ 'marketing.tiktok.cta_hint' | transloco }}</p>
    </div>
  </div>
</div>
